/** @format */

import { createAsyncThunk } from "@reduxjs/toolkit";
import { alertMsg } from "../utilities/helper";

import { deleteReq, getReq, postReq } from "./APIMethods";

export const getAllManagers = createAsyncThunk(
  "managers/getAll",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq("/moderators?page=" + obj);

      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);
export const getOneManager = createAsyncThunk(
  "managers/getOne",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq("/moderators/" + obj);

      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);
export const baneManager = createAsyncThunk(
  "managers/baneManager",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await postReq(obj.url, obj.params);

      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);
export const addManagerAction = createAsyncThunk(
  "managers/addManager",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await postReq(obj.url, obj.params);

      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);
